import React from 'react';
import TPEAction from 'src/models/common/TPEAction';
import ServiceCollection from 'src/services/ServiceCollection';
import { DatasetRecord } from 'src/models/tp-allocation/DatasetRecord';
import WorksheetTotal from 'src/models/tp-allocation/WorksheetTotal';
import { WorksheetTotalsState } from 'src/services/tp-allocation/totals/WorksheetTotalsState';

/** Context shared by the Step 2 section and grid. */
export interface DasTotalsContextType {
    services: ServiceCollection;
    totalsState: WorksheetTotalsState;
    totalsDispatch: React.Dispatch<TPEAction>;
    dataSources: DatasetRecord[];
    viewMode: string;
    sheetId: string;
}

export const DasTotalsContext = React.createContext(null as unknown as DasTotalsContextType);
